import * as React from 'react'
import styled from 'styled-components'
import * as constants from 'static/constants'
import * as interfaces from 'static/interfaces'
import { agentService } from 'core/services'
import { Button, CheckBox } from 'components/atoms'
import { getGroupUnassignedTourGuidesByStatus } from 'utils/weekly'
import moment from 'moment'
import { IBuildedTour } from 'utils/weeklyTypes'
import Typography from 'components/atoms/_layouts/Typography'
import I18n from 'core/i18n'

declare var window: interfaces.IWindow

interface IProps {
  tour: IBuildedTour
  tourGuideId?: number
}

export const CancelSoundoutModalBody = React.memo(({ tour, tourGuideId }: IProps) => {
  const [sendCancelNotification, setSendCancelNotification] = React.useState(true)
  const [sending, setSending] = React.useState(false)

  const [_, approvedGuides, soundoutedGuides] = React.useMemo(() => {
    return getGroupUnassignedTourGuidesByStatus(tour.unAssignedTourGuides)
  }, [tour.unAssignedTourGuides])

  const targetGuides = [...approvedGuides, ...soundoutedGuides].filter(
    tg => tourGuideId == null || tg.id === tourGuideId
  )

  const startAt =
    tour.day && tour.start_time ? moment(tour.day).format(`YYYY/MM/DD ${tour.start_time}`) : ''

  const tourName = tour.post.name
  const cancelMessage =
    tourGuideId == null
      ? `${startAt}催行の${tourName}のガイド募集が締め切られました`
      : `${startAt}の${tourName}の打診がキャンセルされました`

  const submit = async () => {
    if (sending) {
      return
    }
    setSending(true)
    try {
      if (tourGuideId == null) {
        await agentService.cancelSoundOutAll(tour.id, sendCancelNotification)
      } else {
        await agentService.cancelSoundOut(tour.id, tourGuideId, sendCancelNotification)
      }
      window.flashMessages.addMessage({ text: I18n.t('generic.send_success') })
      window.globalModal.closeModal()
      location.reload()
    } finally {
      setSending(false)
    }
  }

  return (
    <CancelPreview>
      <div className="cancel_preview_header">
        <Typography type="subtitle" size="lg">
          対象ガイド
        </Typography>
        <Typography size="lg">
          {targetGuides
            .map(({ guide }) =>
              tourGuideId == null
                ? guide.username
                : `${guide.fullname || '本名未設定'}（${guide.username}）`
            )
            .join(', ')}
        </Typography>
      </div>
      <Typography type="subtitle" size="xl">
        本文
      </Typography>
      <div className="message_preview_content">
        <div className="message_preview">
          <Typography>{cancelMessage}</Typography>
        </div>
      </div>
      <CheckBox
        name="sendCancelNotification"
        label="キャンセル通知を送信する"
        showLabelInline={true}
        checked={sendCancelNotification}
        onChangeHandler={e => setSendCancelNotification(e.target.checked)}
      />
      <Button handleClick={submit} disabled={sending || targetGuides.length === 0}>
        {tourGuideId == null ? '全ての打診中ガイドをキャンセル' : '打診をキャンセル'}
      </Button>
    </CancelPreview>
  )
})

const CancelPreview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .cancel_preview_header {
    display: inline-flex;
    flex-direction: column;
    gap: 8px;
  }

  .message_preview_content {
    display: inline-flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid ${constants.COLORS.divider2};
    .message_preview {
      display: inline-flex;
      flex-direction: column;
      gap: 8px;
    }
  }
`
